export const SIGNALR_EVENTS = ['RefreshLocations'];
